import SoundWave from '@components/icons/SoundWave.svg';
import { Footer } from '../Footer';
import { TProps } from './types/TProps';

export const WrongAccountContent = ({ orgName, invitedEmail, currentEmail, onSwitchAccount }: TProps) => {
  return (
    <div className="content">
      <p>
        This invitation to <b>{orgName}</b> {invitedEmail ? <>was sent to {invitedEmail}</> : <>belongs to</>} another
        account.
      </p>
      <div className="text">
        {currentEmail ? <>You are signed in as {currentEmail}.</> : null} Sign in with the invited account to accept it.
      </div>

      <SoundWave />

      <div className="signInButton">
        <p className="signLink" onClick={onSwitchAccount}>
          Sign in with another account
        </p>
      </div>

      <Footer />
    </div>
  );
};
